<template>
  <div>
    <Pane />

    <div class="container">
      <a-form
        :form="form"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 12 }"
        :colon="false"
        @submit="handleSubmit"
      >
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="盘点名称">
              <a-input
                v-decorator="[
                  'inventoryName',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请输入！',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="盘点类型">
              <a-select
                v-decorator="[
                  'inventoryType',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              >
                <a-select-option
                  v-for="item in ['全面盘点', '部门盘点', '专项盘点']"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="盘点开始日期">
              <a-date-picker
                style="width: 100%"
                placeholder=""
                v-decorator="[
                  'startDate',
                  { rules: [{ required: true, message: '请选择！' }] },  
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="盘点结束日期">
              <a-date-picker
                style="width: 100%"
                placeholder=""
                v-decorator="[
                  'endDate',
                  { rules: [{ required: true, message: '请选择！' }] },  
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="盘点执行人">
              <a-select
                v-decorator="[
                  'executorType',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              >
                <a-select-option
                  v-for="item in ['资产负责人', '部门指定对接人']"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        
        <div class="center">
          <a-space>
            <a-button type="primary" html-type="submit" :loading="loading"
              >保存</a-button
            >
            <a-button @click="$close($route.path)">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import request from "@/api/request";
import { mapGetters } from "vuex";
import moment from "moment";
function add(data) {
  return request({
    url: "/office-service/fixed/asset/inventory/master/update",
    data,
    method: 'post'
  });
}
function getDetail(id) {
  return request({
    url: "/office-service/fixed/asset/inventory/master/detail/" + id,
  });
}
export default {
  name: "addFixedAssetsInventory",

  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      id: null,
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
  },
  mounted() {
    const id = this.$route.query.id;
    this.id = id;
    if (id) {
      getDetail(id).then((res) => {
        this.form.setFieldsValue(res);
      });
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;

          add({
            ...values,
            id: this.id,
            startDate: moment(values.startDate).format("YYYY-MM-DD"),
            endDate: moment(values.endDate).format("YYYY-MM-DD"),
          })
            .then(() => {
              this.form.resetFields();
              this.$close(this.$route.path);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}

.center {
  margin-top: 80px;
}
</style>
